/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useReducer, useState } from "react";
import formReducer from "../../shared/forms/formReducer";
import { TabPanel, TabView } from "primereact/tabview";
import FormHandler from "../../shared/forms/formHandler";
import { Button } from "primereact/button";
import useApiFlotillas from "../../api/comercial/useApiFlotillas";
import constantes from "../../catalogos/constantes";
import DatosGenerales from "./secciones/datosGenerales";
import Especificaciones from "./secciones/especificaciones";
import Documentacion from "./secciones/documentacion";
import Expediente from "./secciones/expediente";
import BajaUnidad from "./secciones/bajaUnidad";
import produce from "immer";
import unidadValidacionEsquema from "./unidadValidacionEsquema";
import alerts from "../../shared/alerts";
import moment from "moment";
import FieldAutoComplete from "../../shared/controls/fieldAutoComplete";
import FieldDropDown from "../../shared/controls/fieldDropDown";
import FieldInputNumber from "../../shared/controls/fieldInputNumber";
import ExportarRuta from "./secciones/ExportarRuta";
import useSeguridad from "../../Seguridad/useSeguridad";

const DetalleUnidad = ({
    onUpdateStatus,
    onSave,
    unidadId,
    onHide,
    soloLectura
}) => {
    const api = useApiFlotillas();

    const [esquemaValidacion, setEsquemaValidacion] = useState(
        unidadValidacionEsquema.guardar
    );

    const [exportarUnidadId, setExportarUnidadId] = useState(null);

    const seguridad = useSeguridad();

    const permisoAsignarUE = seguridad.tieneAcceso(
        constantes.opciones.permisoAsignar
    );

    const MAX_FILE_SIZE = 10 * 1024 * 1024;

    const defaultUnidad = () => ({
        entity: {
            accesorios: [],
        },
    });

    const [{ entity, errors, ...state }, dispatch] = useReducer(
        formReducer,
        {},
        defaultUnidad
    );

    const formHandler = new FormHandler({
        validationSchema: unidadValidacionEsquema.guardar,
        api,
        dispatch,
    });

    /*
     * Cargar la unidad cuando cambia el identificador.
     */
    useEffect(() => {
        const timer = setTimeout(() => {
            loadUnidad();
        }, 100);

        return () => {
            clearTimeout(timer);
        };
    }, [unidadId]);

    /*
     * Volver a validar después de que el formulario fue enviado
     * y posteriormente se modifica algún campo.
     */
    useEffect(() => {
        if (state.submitted === true) {
            formHandler.setValidacionSchema(esquemaValidacion);
            formHandler.validate(entity);
        }
    }, [entity, esquemaValidacion]);

    /*
     * Mostrar exactamente qué campos tienen errores.
     */
    useEffect(() => {
        if (errors && Object.keys(errors).length > 0) {
        }
    }, [errors]);

    const loadUnidad = async () => {
        if (unidadId == null) {
            return;
        }

        const unidad = await api.obtener(unidadId);

        dispatch({
            type: "reset",
            getDefault: () => ({
                entity: unidad,
            }),
        });
    };

    /*
     * callValidation:
     *
     * false = solamente guardar cambios.
     * true  = validar todos los campos para alta o reactivación.
     */
    const save = async (callValidation = false) => {
        const esquema = callValidation
            ? unidadValidacionEsquema.alta
            : unidadValidacionEsquema.guardar;

        setEsquemaValidacion(esquema);
        formHandler.setValidacionSchema(esquema);


        const unidadGuardada = await formHandler.save(entity, true);


        if (formHandler.valdation.result !== true) {


            return null;
        }

        if (!unidadGuardada?.id) {


            return null;
        }

        await subirArchivos(unidadGuardada.id, entity);
        await subirArchivosAccesorios(unidadGuardada.id, entity);

        if (onSave) {
            await onSave();
        }

        return unidadGuardada;
    };

    const cambiarEstadoSuspendida = async (unidad) => {
        const accion = unidad.suspendida
            ? "Activar"
            : "Suspender";

        const confirmado = await alerts.preguntarSiNo(
            `¿Desea ${accion} la unidad?`
        );

        if (confirmado !== true) {
            return;
        }

        await api.cambiarEstadoSuspendida(unidad.id);

        if (onSave) {
            await onSave();
        }

        if (onHide) {
            onHide();
        }
    };

    const cambiarFueraServicio = async (unidad) => {
        const confirmado = await alerts.preguntarSiNo(
            "¿Está seguro de que desea poner la unidad fuera de servicio?"
        );

        if (confirmado !== true) {
            return;
        }

        await api.fueradeServicio(unidad.id);

        if (onSave) {
            await onSave();
        }

        if (onHide) {
            onHide();
        }
    };

    const darDeAlta = async () => {
        const saved = await save(true);

        if (
            saved?.id &&
            formHandler.valdation.result === true
        ) {
            await api.alta(saved.id);

            if (onUpdateStatus) {
                onUpdateStatus();
            }
        }
    };

    async function subirArchivos(id, unidad) {
        const documentacion = unidad?.documentacion ?? [];
        const expediente = unidad?.expediente ?? [];

        let documentos = [
            ...documentacion,
            ...expediente
        ];

        documentos = documentos.filter(
            (documento) => documento.archivo?.file != null
        );

        /*
         * Validar el tamaño de cada archivo, no solamente
         * el primer archivo de la lista.
         */
        const archivoDemasiadoGrande = documentos.find(
            (documento) =>
                documento.archivo?.file?.size > MAX_FILE_SIZE
        );

        if (archivoDemasiadoGrande) {
            alerts.informacion(
                "El archivo es demasiado grande. " +
                "Por favor, selecciona uno menor a 10 MB."
            );

            return;
        }

        if (documentos.length === 0) {
            return;
        }

        const formData = new FormData();

        documentos.forEach((documento) => {
            formData.append(
                "files",
                documento.archivo.file
            );
        });

        formData.append(
            "tiposDocumentos",
            JSON.stringify(
                documentos.map(
                    (documento) => documento.tipoDocumento.id
                )
            )
        );

        await api.subirArchivos(id, formData);
    }

    async function subirArchivosAccesorios(id, unidad) {
        const accesorios = unidad?.accesorios ?? [];

        const formData = new FormData();
        const indexes = [];

        for (let index = 0; index < accesorios.length; index++) {
            const archivo = accesorios[index]?.archivo;

            if (archivo?.file != null) {
                if (archivo.file.size > MAX_FILE_SIZE) {
                    alerts.informacion(
                        "El archivo es demasiado grande. " +
                        "Por favor, selecciona uno menor a 10 MB."
                    );

                    return;
                }

                indexes.push(index);
                formData.append("files", archivo.file);
            }
        }

        if (indexes.length === 0) {
            return;
        }

        formData.append(
            "listIndexes",
            JSON.stringify(indexes)
        );

        await api.subirArhivosAccesorios(id, formData);
    }

    const update = (value, name) => {
        dispatch({
            type: "update",
            value,
            name,
        });
    };

    const updateEquipo = (datosGenerales) => {
        const updated = {
            ...entity,
            datosGenerales,
            expediente: getExpedientes(
                datosGenerales,
                "Expediente"
            ),
        };

        dispatch({
            type: "update",
            value: updated,
        });
    };

    const updateNacionalCruce = (datosGenerales) => {
        const updated = produce(
            entity ?? {},
            (draft) => {
                draft.datosGenerales = datosGenerales;

                draft.documentacion = getDocumentos(
                    datosGenerales,
                    datosGenerales.nacionalCruce
                );

                const tarjetasCruce =
                    draft.especificaciones?.tarjetasCruce ?? [];

                draft.especificaciones.tarjetasCruce =
                    tarjetasCruce.map((elemento) => {
                        const esCruce =
                            datosGenerales.nacionalCruce.id ===
                            constantes.nacionalCruce.cruce;

                        const esTarjetaRequerida =
                            elemento.tarjetaCruce.id ===
                                constantes.tarjetaCruce.tagAnzalduas ||
                            elemento.tarjetaCruce.id ===
                                constantes.tarjetaCruce.tagPharr;

                        return {
                            ...elemento,
                            requerido:
                                esCruce && esTarjetaRequerida
                                    ? true
                                    : !esCruce
                                        ? elemento.tarjetaCruce.requerido
                                        : false,
                        };
                    });
            }
        );

        dispatch({
            type: "update",
            value: updated,
        });
    };

    function getDocumentos(
        datosGenerales,
        nacionalCruce
    ) {
        const documentosTipoUnidad =
            datosGenerales?.tipoUnidad?.documentos ?? [];

        const documentosGuardados =
            entity?.documentos ?? [];

        const documentos = documentosTipoUnidad
            .filter(
                (documento) =>
                    documento.nacionalCruceId ===
                    nacionalCruce?.id
            )
            .map((documento) => ({
                tipoDocumento: documento,
            }));

        documentos.forEach((documento) => {
            const documentoExistente =
                documentosGuardados.find(
                    (guardado) =>
                        guardado.tipoDocumento.id ===
                        documento.tipoDocumento.id
                );

            if (documentoExistente) {
                documento.id = documentoExistente.id;
                documento.archivo =
                    documentoExistente.archivo;
                documento.vigencia =
                    documentoExistente.vigencia;
            }
        });

        return documentos;
    }

    function getExpedientes(
        datosGenerales,
        seccion
    ) {
        const documentos =
            datosGenerales?.tipoEquipo?.documentos ?? [];

        return documentos
            .filter(
                (documento) =>
                    documento.seccion === seccion
            )
            .map((documento) => ({
                tipoDocumento: documento,
            }));
    }

    const reactivar = async () => {
        const saved = await save(true);

        if (
            saved?.id &&
            formHandler.valdation.result === true
        ) {
            await api.reactivar(saved.id);

            if (onUpdateStatus) {
                onUpdateStatus();
            }
        }
    };

    return (
        <>
            <div className="form-container full-height">
                <TabView activeIndex={0}>
                    <TabPanel
                        header="GENERALES"
                        rightIcon={
                            errors?.datosGenerales
                                ? "pi pi-exclamation-circle"
                                : ""
                        }
                    >
                        <DatosGenerales
                            datosGenerales={
                                entity?.datosGenerales ?? {}
                            }
                            codigoUnidad={entity?.codigoUnidad}
                            onChange={update}
                            name="datosGenerales"
                            onUpdateEquipo={updateEquipo}
                            onUpdateNacionalCruce={
                                updateNacionalCruce
                            }
                            errors={errors?.datosGenerales}
                        />
                    </TabPanel>

                    <TabPanel
                        header="ESPECIFICACIONES"
                        rightIcon={
                            errors?.especificaciones ||
                            errors?.familiares
                                ? "pi pi-exclamation-circle"
                                : ""
                        }
                        headerStyle={{
                            display:
                                entity?.datosGenerales
                                    ?.esMotriz !== true
                                    ? "none"
                                    : "",
                        }}
                    >
                        <Especificaciones
                            especificaciones={
                                entity?.especificaciones ?? {}
                            }
                            errors={
                                errors?.especificaciones ?? {}
                            }
                            onChange={update}
                            name="especificaciones"
                        />
                    </TabPanel>

                    <TabPanel
                        header="DOCUMENTACIÓN"
                        rightIcon={
                            errors?.documentacion
                                ? "pi pi-exclamation-circle"
                                : ""
                        }
                        headerStyle={{
                            display:
                                entity?.datosGenerales
                                    ?.tipoEquipo == null
                                    ? "none"
                                    : "",
                        }}
                    >
                        <Documentacion
                            name="documentacion"
                            documentacion={
                                entity?.documentacion ?? []
                            }
                            onChange={update}
                            errors={errors ?? {}}
                        />
                    </TabPanel>

                    <TabPanel
                        header="EXPEDIENTE"
                        rightIcon={
                            errors?.expediente ||
                            errors?.accesorios
                                ? "pi pi-exclamation-circle"
                                : ""
                        }
                        headerStyle={{
                            display:
                                entity?.datosGenerales
                                    ?.tipoEquipo == null
                                    ? "none"
                                    : "",
                        }}
                    >
                        <Expediente
                            errors={errors ?? {}}
                            onChange={update}
                            expediente={
                                entity?.expediente ?? []
                            }
                            accesorios={
                                entity?.accesorios ?? []
                            }
                        />
                    </TabPanel>

                    <TabPanel
                        header="TRAFICO"
                        rightIcon={
                            errors?.operador ||
                            errors?.coordinador
                                ? "pi pi-exclamation-circle"
                                : ""
                        }
                    >
                        {entity?.datosGenerales?.esMotriz && (
                            <FieldAutoComplete
                                name="operador"
                                label="Operador Asignado"
                                colMd={6}
                                source="empleados"
                                filter
                                errors={errors}
                                className="dropdown-bottom"
                                params={{
                                    puestoIds: [
                                        constantes.puestos.operador
                                    ],
                                    todasLasEmpresas: true,
                                }}
                                value={entity?.operador}
                                onChange={update}
                            />
                        )}

                        <FieldAutoComplete
                            name="coordinador"
                            label="Coordinador Asignado"
                            colMd={6}
                            source="empleados"
                            filter
                            errors={errors}
                            className="dropdown-bottom"
                            params={{
                                puestoIds: [
                                    constantes.puestos
                                        .coordinadorTrafico,
                                    constantes.puestos
                                        .auxiliarTrafico,
                                ],
                                todasLasEmpresas: true,
                            }}
                            value={entity?.coordinador}
                            onChange={update}
                        />

                        {entity?.datosGenerales?.esMotriz && (
                            <FieldDropDown
                                name="unidadTipoRutaId"
                                label="Tipo Ruta"
                                colMd={6}
                                source="unidadesTipoRuta"
                                errors={errors}
                                showClear={false}
                                value={
                                    entity?.unidadTipoRutaId
                                }
                                valueById
                                onChange={update}
                            />
                        )}

                        {permisoAsignarUE && (
                            <FieldDropDown
                                name="estacionUnidad"
                                label="Estación"
                                colMd={6}
                                source="estaciones"
                                errors={errors}
                                showClear={false}
                                value={
                                    entity?.estacionUnidad
                                }
                                valueById
                                onChange={update}
                            />
                        )}

                        {permisoAsignarUE && (
                            <FieldDropDown
                                name="unidadNegocioId"
                                label="Unidad de Negocio"
                                colMd={6}
                                source="unidadesNegocio"
                                required
                                errors={errors}
                                showClear={false}
                                value={
                                    entity?.unidadNegocioId
                                }
                                valueById
                                onChange={update}
                            />
                        )}

                        {entity?.datosGenerales?.esMotriz && (
                            <FieldInputNumber
                                name="metaDiaria"
                                label="Meta Diaria"
                                colMd={6}
                                errors={errors}
                                value={entity?.metaDiaria}
                                onChange={update}
                            />
                        )}
                    </TabPanel>

                    <TabPanel header="SERVICIO">
                        <table className="table table-sm">
                            <thead className="thead-light">
                                <tr>
                                    <th>SERVICIO SAAS</th>
                                </tr>
                            </thead>

                            <tbody>
                                {entity?.unidadServicioSaaS?.map(
                                    (item) => (
                                        <tr key={item?.id}>
                                            <td>
                                                {
                                                    item?.servicioSaaS
                                                }
                                            </td>
                                        </tr>
                                    )
                                )}
                            </tbody>
                        </table>
                    </TabPanel>

                    <TabPanel header="HISTORIAL">
                        <div className="form-row">
                            <table className="table">
                                <thead className="thead-light">
                                    <tr>
                                        <th
                                            scope="col"
                                            style={{ width: "15%" }}
                                        >
                                            TIPO
                                        </th>

                                        <th
                                            scope="col"
                                            style={{ width: "15%" }}
                                        >
                                            FECHA
                                        </th>

                                        <th
                                            scope="col"
                                            style={{ width: "15%" }}
                                        >
                                            MOTIVO
                                        </th>

                                        <th
                                            scope="col"
                                            style={{ width: "20%" }}
                                        >
                                            USUARIO
                                        </th>

                                        <th
                                            scope="col"
                                            style={{ width: "35%" }}
                                        >
                                            COMENTARIOS
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {entity?.historial?.map(
                                        (item, index) => (
                                            <tr key={index}>
                                                <td>{item.tipo}</td>

                                                <td>
                                                    {moment(
                                                        item.fecha
                                                    ).format(
                                                        "DD/MM/YYYY"
                                                    )}
                                                </td>

                                                <td>{item.motivo}</td>

                                                <td>{item.usuario}</td>

                                                <td>
                                                    {
                                                        item.comentarios
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </TabPanel>
                </TabView>
            </div>

            <div className="form-footer">
                {!soloLectura && (
                    <>
                        <Button
                            label="Exportar Ruta"
                            className="p-button-outlined"
                            type="button"
                            onClick={() =>
                                setExportarUnidadId(entity?.id)
                            }
                        />

                        {entity?.estatus !==
                            constantes.estatus.unidades.baja && (
                            <Button
                                label={
                                    entity?.suspendida
                                        ? "Activar"
                                        : "Suspender"
                                }
                                className="p-button-outlined"
                                type="button"
                                onClick={() =>
                                    cambiarEstadoSuspendida(
                                        entity
                                    )
                                }
                            />
                        )}

                        <Button
                            label="Fuera de Servicio"
                            className="p-button-outlined"
                            type="button"
                            onClick={() =>
                                cambiarFueraServicio(entity)
                            }
                        />

                        {(entity?.estatus ===
                            constantes.estatus.unidades.alta ||
                            entity?.estatus ===
                                constantes.estatus.unidades
                                    .fueradeServicio) && (
                            <BajaUnidad
                                onBaja={onUpdateStatus}
                                unidad={entity}
                            />
                        )}

                        {entity?.estatus !==
                            constantes.estatus.unidades.baja && (
                            <Button
                                label="Guardar"
                                className="p-button-outlined"
                                type="button"
                                onClick={() => save(false)}
                                disabled={
                                    entity?.datosGenerales
                                        ?.tipoEquipo == null
                                }
                            />
                        )}

                        {entity?.estatus ===
                            constantes.estatus.unidades
                                .enProceso && (
                            <Button
                                label="Dar de Alta"
                                type="button"
                                onClick={darDeAlta}
                                disabled={
                                    entity?.datosGenerales
                                        ?.tipoEquipo == null
                                }
                            />
                        )}

                        {entity?.estatus ===
                            constantes.estatus.unidades.baja && (
                            <Button
                                label="Reactivar"
                                className={
                                    "p-button-outlined " +
                                    "btn-outline-info"
                                }
                                type="button"
                                onClick={reactivar}
                                disabled={
                                    entity?.datosGenerales
                                        ?.tipoEquipo == null
                                }
                            />
                        )}
                    </>
                )}
            </div>

            <ExportarRuta
                exportarUnidadId={exportarUnidadId}
                onCancel={() =>
                    setExportarUnidadId(null)
                }
            />
        </>
    );
};

export default DetalleUnidad;